import { usePhoneMask } from "@/hooks/use-masks";
import { cn } from "@/utils/theme";
import { Badge, Input } from "@elaniintc/goes-design-system";
import type { ComponentProps } from "react";

export const InputPhone = ({
  className,
  ...props
}: ComponentProps<typeof Input>) => {
  const phoneMask = usePhoneMask();
  return (
    <div className="relative w-full">
      <Input {...props} ref={phoneMask} className={cn("pl-17.5", className)} />
      <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
        <Badge className="h-6 text-sm">+503</Badge>
      </div>
    </div>
  );
};
